import { C } from "../../constants/theme";
import { useId } from "react";

export function Sel({ label, children, ...p }) {
  const generatedId = useId();
  const id = p.id || generatedId;
  return (
    <div style={{ display:"flex", flexDirection:"column", gap:4, minWidth:0 }}>
      {label && <label htmlFor={id} style={{ color:C.muted, fontSize:12, fontWeight:600, letterSpacing:1 }}>{label}</label>}
      <select {...p} id={id} style={{ background:C.panel, border:"1px solid "+C.border, borderRadius:8, color:C.text, padding:"9px 14px", fontSize:14, outline:"none", width:"100%", boxSizing:"border-box", ...p.style }}>{children}</select>
    </div>
  );
}
